import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type LoginInputsProps = {
  email: {
    error: boolean,
    value: string,
    helperText?: string | false | undefined,
  },
  password: {
    error: boolean,
    value: string,
    helperText?: string | false | undefined,
  },
  onBlur: (event: React.FocusEvent) => void,
  onChange: (event: React.ChangeEvent) => void,
}

const LoginInputs = ({
  email, password, onBlur, onChange,
}: LoginInputsProps): JSX.Element =>  {
  const { t: translate } = useTranslation();

  return (
    <>
      <TextField
        name="email"
        error={ email.error }
        margin={ style.margin }
        required
        fullWidth
        label={ translate(STRING_KEYS.LOGIN_EMAIL_LABEL) }
        value={ email.value }
        helperText={ email.helperText }
        onBlur={ onBlur }
        onChange={ onChange }
      />
      <TextField
        name="password"
        error={ password.error }
        margin={ style.margin }
        required
        fullWidth
        value={ password.value }
        helperText={ password.helperText }
        label={ translate(STRING_KEYS.LOGIN_PASSWORD_LABEL) }
        type={ style.passwordType }
        onBlur={ onBlur }
        onChange={ onChange }
      />
    </>
  );
};

export default LoginInputs;
